import { z } from 'zod'
import { couponTypeSchema } from '../couponTypes'

// Definiere die Struktur eines einzelnen Coupon-Items
export interface CouponItem {
  orderId?: number
  orderDate?: Date
  discount?: number
}

// Zod-Schema für ein einzelnes Coupon-Item
const CouponItem: z.ZodType<CouponItem> = z.lazy(() =>
  z.object({
    orderId: z.number().optional(),
    orderDate: z.date().optional(),
    discount: z.number().optional(),
  })
)

// Zod-Schema für ein Array von Coupon-Items
export const couponItemsSchema = z.array(CouponItem)
export type CouponItems = z.infer<typeof couponItemsSchema>

export const couponPromotionColorSchema = z.enum(['green', 'red', 'black'])
export const couponPromotionSchema = z.object({
  enabled: z.boolean().optional(),
  title: z.string().optional(),
  text: z.string().optional(),
  badgeText: z.string().optional(),
  color: couponPromotionColorSchema.optional(),
  showOnListing: z.boolean().optional(),
  showOnProduct: z.boolean().optional(),
})
export type CouponPromotion = z.infer<typeof couponPromotionSchema>

// Zod-Schema für den Coupon
export const couponSchema = z.object({
  id: z.number(),
  title: z.string(),
  type: couponTypeSchema,
  code: z.string().optional(),
  slogan: z.string().optional(),
  balance: z.string().optional(),
  brand: z.number().optional(),
  categories: z.array(z.number()).optional(),
  products: z.array(z.number()).optional(),
  shops: z.array(z.number()).optional(),
  isMultiUse: z.boolean().optional(),
  usageLimit: z.number().nullable().optional(),
  active: z.boolean().optional(),
  stackable: z.boolean().optional(),
  promotion: couponPromotionSchema.optional(),
  ebay: z.object({
    enabled: z.boolean().optional(),
    balance: z.string().optional(),
    inventoryMode: z.enum(['all', 'priceRange']).optional(),
    selectionMode: z.enum(['all', 'storeCategories']).optional(),
    categoryIds: z.array(z.string()).optional(),
    endDate: z.string().nullable().optional().transform(val => val ? new Date(val) : undefined),
    minPrice: z.number().optional(),
    maxDiscountAmount: z.number().optional(),
    priceFrom: z.number().optional(),
    priceTo: z.number().optional(),
    promotionId: z.string().optional(),
    syncedAt: z.string().nullable().optional().transform(val => val ? new Date(val) : undefined),
    lastError: z.string().optional(),
  }).optional(),
  coupon: couponItemsSchema.optional().default([]),
  created: z.string().transform(val => new Date(val)), // wenn du immer einen ISO-String bekommst
  changed: z.string().transform(val => new Date(val)),
  expirationDate: z.string().optional().transform(val => val ? new Date(val) : undefined),
  deleted: z.literal(true).optional(),
})
export type tcoupon = z.infer<typeof couponSchema>
export const couponFrontendSchema = couponSchema;
export type tcouponFrontend = z.infer<typeof couponFrontendSchema>;
